import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Dashboard from "./views/Dashboard";
import Requests from "./views/Requests";
import RequestDetails from "./views/RequestDetails";
import Users from "./views/Users";
import UserDetails from "./views/UserDetails";
import Register from "./views/Register";
import Reports from "./views/Reports";
import MyServices from "./views/MyServices";
import OpenRequests from "./views/OpenRequests";
import ResetPassword from "./views/ResetPassword";
import RequestViews from "./views/RequestViews";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: { requiresAuth: false }
    },
    {
      path: "/login",
      name: "login",
      meta: { requiresAuth: false },
      // route level code-splitting
      // this generates a separate chunk (login.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Login.vue")
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: { requiresAuth: true }
    },
    {
      path: "/requests",
      name: "requests",
      component: Requests,
      meta: { requiresAuth: true }
    },
    {
      path: "/open-requests",
      name: "open-requests",
      component: OpenRequests,
      meta: { requiresAuth: true }
    },
    {
      path: "/open-requests/:id",
      name: "open-request-details",
      component: RequestDetails,
      meta: { requiresAuth: true }
    },
    {
      path: "/requests/:id",
      name: "request-details",
      component: RequestDetails,
      meta: { requiresAuth: true }
    },
    {
      path: "/users",
      name: "users",
      component: Users,
      meta: { requiresAuth: true }
    },
    {
      path: "/users/:id",
      name: "user-details",
      component: UserDetails,
      meta: { requiresAuth: true }
    },
    {
      path: "/register",
      name: "register",
      component: Register,
      meta: { requiresAuth: false }
    },
    {
      path: "/reports",
      name: "reports",
      component: Reports,
      meta: { requiresAuth: true }
    },
    {
      path: "/my-services",
      name: "my-services",
      component: MyServices,
      meta: { requiresAuth: true }
    },
    {
      path: "/reset-password",
      name: "reset-password",
      component: ResetPassword,
      meta: { requiresAuth: false }
    },
    {
      path: "/views/:code",
      name: "request-views",
      component: RequestViews,
      meta: { requiresAuth: false }
    }
  ]
});

function isUserAuthenticated() {
  return localStorage.getItem("token") !== null;
}

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isUserAuthenticated()) {
      next({
        path: "/login"
      });
    }
  }
  next();
});

export default router;
